<template>
  <tab-list
      v-model="currentTab"
      :tabs-enum="tabs"
      :title="title"
      fixed-tabs
      :default-tab="defaultTab"
      @change="changeTab">
    <template v-slot:tabItem="{ current }">
      <users-list :status="current" />
    </template>
  </tab-list>
</template>

<script>
  import UsersList from './UsersList.vue'
  import TabList from '@/components/reused/ui/TabList.vue'
  import { USER_LIST_TABS_ENUM } from '@/constants/enums'
  import { USER_TYPES } from '@/constants/business'

  export default {
    components: {
      TabList,
      UsersList
    },
    props: {
      tab: {
        type: String
      }
    },
    data () {
      return {
        tabs: USER_LIST_TABS_ENUM,
        currentTab: this.tab || USER_TYPES.REGISTERED,
        defaultTab: USER_TYPES.REGISTERED
      }
    },
    computed: {
      title () {
        return this.$t('Список уполномоченных представителей')
      }
    },
    methods: {
      changeTab: function (tabValue) {
        this.replaceCurrentRoute(this.getRoute(tabValue))
      },
      getRoute: function (tabValue) {
        return `${this.urlRootPath}/users/${tabValue}`
      }
    }
  }
</script>
